<div class="form-inline bar-filter-panel-fields d-flex align-items-center gap-3">
  <ng-container #filtersTarget></ng-container>
  
  <div class="pull-right bar-filter-panel-btns d-flex  gap-3">
    <ng-container #btnsTarget></ng-container>
  </div>
</div>